export default __webpack_public_path__ + "static/media/db2c823e9ecd3576.b9892fec91477eef18210853cdfe360a.svg";